(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-styles"] && !Shopify.designMode) return;
  try {
    // "+N more colours" on product cards.
  //
  // Colourways are separate product listings sharing a base title (everything
  // before ' - '), shown on the front end as if they were variants. The counts
  // are built from the gender collections, which are storefront feeds and so
  // contain live products only. Drafts can never be counted.
  (function () {
    var FEEDS = [
      '/collections/all-mens-footwear?view=colourways',
      '/collections/all-mens-footwear?view=colourways&page=2',
      '/collections/all-womens-footwear?view=colourways',
      '/collections/all-womens-footwear?view=colourways&page=2'
    ];
    var indexPromise = null;

    function getIndex() {
      if (indexPromise) return indexPromise;
      indexPromise = Promise.all(
        FEEDS.map(function (u) {
          return fetch(u)
            .then(function (r) { return r.ok ? r.text() : '[]'; })
            .then(function (t) { try { return JSON.parse(t); } catch (e) { return []; } })
            .catch(function () { return []; });
        })
      ).then(function (pages) {
        var byHandle = {}, family = {};
        pages.forEach(function (list) {
          list.forEach(function (p) {
            if (!p || !p.handle || byHandle[p.handle]) return;
            var base = String(p.title).split(' - ')[0].toLowerCase();
            var gender = /ladies|women/i.test(p.title) ? 'w' : 'm';
            p._key = base + '|' + gender;
            byHandle[p.handle] = p;
            family[p._key] = (family[p._key] || 0) + 1;
          });
        });
        return { byHandle: byHandle, family: family };
      });
      return indexPromise;
    }

    function annotate() {
      var cards = document.querySelectorAll('.product-grid__item, .resource-list__item');
      if (!cards.length) return;
      getIndex().then(function (ix) {
        cards.forEach(function (card) {
          if (card.querySelector('.ctrne-card-colours')) return;
          var link = card.querySelector('a[href*="/products/"]');
          if (!link) return;
          var handle = (link.getAttribute('href') || '').split('/products/')[1];
          if (!handle) return;
          handle = handle.split('?')[0].split('#')[0];
          var p = ix.byHandle[handle];
          if (!p) return;
          var n = (ix.family[p._key] || 1) - 1;
          if (n < 1) return;
          var el = document.createElement('div');
          el.className = 'ctrne-card-colours';
          el.textContent = '+' + n + ' more colour' + (n > 1 ? 's' : '');
          (card.querySelector('.product-card__content') || card).appendChild(el);
        });
      });
    }

    if (document.readyState !== 'loading') annotate();
    else document.addEventListener('DOMContentLoaded', annotate);
    document.addEventListener('shopify:section:load', annotate);
  })();
  } catch(e) { console.error(e); }
})();

})();
